export default [
  {
    path: '/settings/outsourcing-pricing',
    name: 'outsourcing-pricing',
    props: true,
    component: () => import('@/views/settings/OutsourcingPricing.vue'),
    meta: {
      requireLogin: true,
      requiresAdmin: true,
      pageTitle: 'Tarifs sous-traitance',
      breadcrumb: [
        {
          text: 'Paramètres',
          to: { name: 'parameters' },
        },
        {
          text: 'Tarifs sous-traitance',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin'],
    },
  },
]
